import React from 'react';

import MTable from 'views/MTable/MTable';
import MRadioGroup from 'views/MRadioGroup/MRadioGroup';

import { useTranslation } from 'react-i18next';
import { HomeAgentTableViewsData } from './HomeAgentTableViews.model';
import { MColumnOptions } from 'views/MTable/Table.model';

interface Props {
  data: HomeAgentTableViewsData[];
  columns: string[];
  columnsOptions: MColumnOptions<HomeAgentTableViewsData>;
  limitState: number;
  onChangeDisplay: (value: React.ChangeEvent<HTMLInputElement>) => void;
}

const HomeAgentTableViewsView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {props.data.length ? (
        <MRadioGroup
          name="limitDisplay"
          value={props.limitState.toString()}
          options={[
            { id: '5', label: t('agent.radioButton.showFive') },
            { id: '10', label: t('agent.radioButton.showTen') },
          ]}
          onChange={props.onChangeDisplay}
        ></MRadioGroup>
      ) : null}
      <MTable
        data={props.data}
        columns={props.columns}
        columnsOptions={props.columnsOptions}
        loading={false}
        hideSelection
        disableFilters
      ></MTable>
    </React.Fragment>
  );
};

HomeAgentTableViewsView.displayName = 'HomeAgentTableViewsView';
HomeAgentTableViewsView.defaultProps = {};

export default HomeAgentTableViewsView;
